<mbs-alert
  [icon]="true"
  [type]="alertType.warning">
  System time is incorrect on this machine. Difference at least {{ getInvalidDiffTime(timeToExpire) }} min/sec
</mbs-alert>
